import { forwardRef, useImperativeHandle, useRef } from 'react';

import ContentEditor from '@sayyesschool/frontend/components/content-editor';
import { STORAGE_API_URL } from '@sayyesschool/frontend/constants';

function TextItem({ content }, ref) {
    const editorRef = useRef();

    useImperativeHandle(ref, () => ({
        get props() {
            return {
                content: editorRef.current?.getData()
            };
        }
    }));

    return (
        <ContentEditor
            ref={editorRef}
            content={content}
            uploadUrl={`${STORAGE_API_URL}`}
        />
    );
}

export default forwardRef(TextItem);